<template>
  <v-app-bar app :height="56" :flat="true" :class="$vuetify.display.xs ? 'bg-yellowBack' : 'bg-whiteishBack'">
    <v-container v-if="!$vuetify.display.xs" fluid class="main-app-container d-flex justify-space-between align-center">
      <layout-sidebar-button v-if="showProductFilters || showContentMenu || showPdfContentMenu" />
      <!-- Temporary placeholder so that main app bar doesnt break until app bar is redesigned and remade -->
      <div v-else :style="{ width: '150px' }"></div>
      <search-bar class="d-none d-sm-block" />
      <layout-user-actions />
    </v-container>

    <v-container v-else class="d-flex justify-space-between align-center">
      <v-icon :icon="`fa-light fa-bars${drawerStore.drawerMobileOpen ? '-staggered' : ''}`" @click="toggleDrawer" />

      <div class="soma-logo align-center justify-center">
        <span class="d-flex align-center">
          <img v-show="!showFallback" :src="logoUrl" alt="Soma Logo" class="logo-image" @error="handleError" />
          <v-icon v-show="showFallback" icon="custom:somaLogo" :size="40" />
          <p>Soma</p>
        </span>
      </div>

      <layout-user-actions-profile-menu />
    </v-container>
  </v-app-bar>
</template>

<script>
import { useLogo } from "~/composables/useLogo"
import { contentMenuVisible, productFiltersVisible, pdfContentMenuVisible } from "~/helpers"
import { useDrawerStore } from "~/stores/drawerStore"
import { useUserStore } from "~/stores/userStore"

export default {
  setup() {
    const drawerStore = useDrawerStore()
    const userStore = useUserStore()
    const { logoUrl, showFallback, handleError } = useLogo()
    return { drawerStore, userStore, logoUrl, showFallback, handleError }
  },

  computed: {
    currentUser() {
      return this.userStore.current
    },

    showContentMenu() {
      return (
        this.userStore.current &&
        contentMenuVisible(this.$route) &&
        (["pro", "plus"].includes(this.currentUser.plan) || this.currentUser.whitelisted || this.currentUser.admin)
      )
    },

    showProductFilters() {
      return productFiltersVisible(this.$route)
    },

    showPdfContentMenu() {
      return pdfContentMenuVisible(this.$route)
    },
  },

  methods: {
    toggleDrawer() {
      this.drawerStore.toggleMobileDrawer()
      this.drawerStore.closeContentMenu()
    },
  },
}
</script>

<style lang="sass">
.soma-logo
  width: 160px
  height: 40px
  display: flex
  gap: 7px
  .logo-image
    width: 40px
    height: 40px
    object-fit: contain
  img
    width: 46px
    height: 50px
  p
    font-weight: 900
    font-size: 29px
    line-height: 29px
</style>
